import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { translate } from 'react-i18next'
import Helmet from 'react-helmet'
import styled from 'styled-components'
import logo from '../../assets/images/logo.svg'
import bg from '../../assets/images/bg.jpg'
import arrow from '../../assets/images/arrow.svg'
import TemplatesSection from './Templates'

class Welcome extends Component {
  static propTypes = {
    items: PropTypes.array.isRequired,
  }

  render() {
    const { t, items } = this.props

    return (
      <Fragment>
        <Helmet title={t('Welcome')} />
        <HeroSection>
          <h3>{t('Welcome')} {t('to JAM.ron')}</h3>
          <h4>{t('Motto')}</h4>
        </HeroSection>
        <TemplatesSection items={items} />
        <FooterSection>
          <div className="wrapper" />
          <a href="#top"><img src={arrow} alt="top" /></a>
          <a href="//ron.gr"><img src={logo} alt="Ron"/></a>
        </FooterSection>
      </Fragment>
    )
  }
}

const HeroSection = styled.section`
  padding: 25px 5%;
  background-image: url(${bg});
  background-attachment: fixed;
  @media(min-width: 2560px) {
    background-size: cover;
  }
  min-height: 200px;
  h3, h4 { color: white; text-align: center; font-size: 32px; line-height: 1; }
  h3 { font-family: ${props => props.theme.headFontFamily}; margin: 2rem auto 1rem !important; }
  h4 { font-family: ${props => props.theme.handFontFamily}; color: #aaa; max-width: 780px; margin: 0 auto 2rem !important; }
  @media(max-width: 800px) {
    padding-top: 72px;
  }
`

const FooterSection = styled.section`
  text-align: right;
  position: relative;
  height: 120px;
  overflow: hidden;
  background-color: brown;
  .wrapper {
    height: 100%;
    padding: 25px 5%;
    width: 100%;
    background-color: #222;
    position: absolute;
    box-sizing: border-box;
    transform: rotate(-5deg) scale(2) translateY(50%);
    z-index: 1;
  }
  img { height: 44px; position: relative; margin: 4px 5%; top: 40%; z-index: 1; }
  [href="#top"] img {
    float: left;
  }
`

export default translate('tr')(Welcome)



// WEBPACK FOOTER //
// ./src/pages/Welcome/index.jsx